import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Stack,
  Select,
  MenuItem,
  Typography,
  FormControl,
} from "@mui/material";
//Import from project
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { ButtonCreate, SearchTextField } from "../../Utils/Component";
import ClassForm from "../../Components/Class/ClassForm";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import ClassCard from "../../Components/StudyClass/ClassCard/ClassCard";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";
import useGetClassPagination from "../../Hooks/useGetClassPagination";

export default function Class() {
  // Change Language
  const { t } = useContext(AuthContext);
  const [status, setStatus] = useState("All");
  const [type, setType] = useState("All");
  const handleChange = (event) => setStatus(event.target.value);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    page,
    limit,
    loading,
    refetch,
    setPage,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetClassPagination({
    isComplete: status === "All" ? null : status,
    type,
  });

  return (
    <div className="page-container">
      <Stack direction="column" rowGap={2.2}>
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("search")}
              </Typography>
              <SearchTextField
                className={"text-field"}
                handleSearch={handleSearch}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_status")}
              </Typography>
              <FormControl fullWidth size="small" className={"text-field"}>
                <Select value={status} onChange={handleChange}>
                  <MenuItem value={"All"}> {t("thead_all")} </MenuItem>
                  <MenuItem value={false}> {t("thead_studying")} </MenuItem>
                  <MenuItem value={true}> {t("thead_completed")} </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_type")}
              </Typography>
              <FormControl fullWidth size="small" className={"text-field"}>
                <Select value={type} onChange={(e) => setType(e.target.value)}>
                  <MenuItem value={"All"}>{t("thead_all")}</MenuItem>
                  <MenuItem value={"direct"}>{t("direct")}</MenuItem>
                  <MenuItem value={"online"}>{t("online")}</MenuItem>
                  <MenuItem value={"private"}>{t("private")}</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={12} lg={3} xl={6}>
              <ButtonCreate
                handleOpen={handleOpen}
                classBtn={"btn-create"}
                classIcon={"icon-add"}
              />

              {open && (
                <ClassForm
                  open={open}
                  handleClose={handleClose}
                  setRefetch={refetch}
                  dialogTitle={"Create"}
                />
              )}
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={3}>
          {loading ? (
            <Grid item xs={12}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{
                  height: 320,
                  width: "100%",
                  bgcolor: "white",
                  borderRadius: 1,
                }}
              >
                <LoadingPage />
              </Stack>
            </Grid>
          ) : tableData?.length === 0 || tableData?.length === undefined ? (
            <Grid item xs={12}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{
                  height: 320,
                  width: "100%",
                  bgcolor: "white",
                  borderRadius: 1,
                }}
              >
                <EmptyData />
              </Stack>
            </Grid>
          ) : (
            tableData?.map((data, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={index}>
                <ClassCard data={data} setRefetch={refetch} />
              </Grid>
            ))
          )}
        </Grid>
      </Stack>

      {/* ==================== Pagination  ============================= */}
      <FooterPagination
        totalPages={paginationData?.totalPages}
        totalDocs={paginationData?.totalDocs}
        limit={limit}
        page={page}
        setPage={setPage}
        handleLimit={handleLimit}
        setLoading={setLoading}
      />
    </div>
  );
}
